import { render } from "./PatchNotesApproval.vue?vue&type=template&id=3a3b78fb"
import script from "./PatchNotesApproval.vue?vue&type=script&lang=js"
export * from "./PatchNotesApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__